import React, { useState } from 'react';
import SeachStatus from '../../assets/image/search-status.svg';
import './advanceFilter.scss';
import AdvanceFilterSelectInput from './AdvanceFilterSelectInput';
import InputSelect from '../inputSelect/InputSelect';
import Modal from '../modal/Modal';
import { useDispatch, useSelector } from 'react-redux';
import {
	removeSelectedInput,
	setAdvanceFilter,
	setSelectedInput,
	setSelectedInputValue,
} from '../../store/action/advanceFilter';
import { getFiltersParams } from '../../helper';

const AdvanceFilter = ({
	isOpen,
	advanceFilterOptions,
	onFocusSelectedFilterInput,
	onClose,
	onApply,
	modalLabel,
}) => {
	const dispatch = useDispatch();
	const { selectedInputs } = useSelector((state) => state.advanceFilter);
	const [errorCell, setErrorCells] = useState({});

	return (
		<Modal
			title="Advance Filters"
			isOpen={isOpen}
			onClose={onClose}
			cancelButton={true}
			className="advance-filter-modal"
			headerClassName="advance-filter-header"
			titleClassName="titleClass"
		>
			<div>
				{/* Note */}
				<div className="advance-filter-note">{modalLabel}</div>

				<div className="advance-filter-body">
					<div
						className="px-4"
						style={{
							display: 'flex',
							flexDirection: 'column',
							alignItems: 'center',
							justifyContent: 'center',
							gap: 10,
							padding: '10px 0px',
						}}
					>
						<div className="advance-filter-search">
							<img
								className="advance-filter-search__icon"
								src={SeachStatus}
								alt=""
							/>
							<InputSelect
								placeholder="Search or Select Filter"
								options={advanceFilterOptions}
								returnInputValue={false}
								autoFocus={true}
								onChange={(value) => {}}
								onSelect={(option) => {
									dispatch(setSelectedInput({ key: option.key, label: option.value }));
								}}
								className="input-select-wrapper"
							/>
						</div>

						<div className="overflow-container">
							{selectedInputs?.map((item) => (
								<div
									key={item?.key}
									className={`advance-filter-row ${
										errorCell[item?.key] ? 'advance-filter-row--error' : ''
									}`}
								>
									<AdvanceFilterSelectInput
										label={item?.label}
										options={item?.data}
										returnInputValue={false}
										placeholder={`Select ${item?.label}`}
										value={item?.value}
										autoFocus={true}
										onFocusCb={() => {
											onFocusSelectedFilterInput(item?.key);
										}}
										error={errorCell[item?.key]}
										onSelect={(option) => {
											delete errorCell[item.key];
											dispatch(
												setSelectedInputValue({
													key: item?.key,
													value: option.value,
												}),
											);
										}}
										onChange={(value) => {}}
										removeInput={() => dispatch(removeSelectedInput({ key: item?.key }))}
										className="modalInput"
									/>
								</div>
							))}
						</div>
					</div>
				</div>

				{/* Buttons */}
				<div className="advance-filter-actions">
					<button
						className="advance-filter-btn advance-filter-btn--secondary"
						onClick={onClose}
					>
						Cancel
					</button>
					<button
						disabled={selectedInputs?.length > 0 ? false : true}
						className="advance-filter-btn advance-filter-btn--primary"
						onClick={() => {
							let errors = {};
							if (selectedInputs.length > 0) {
								for (const item of selectedInputs) {
									if (item.value === '' || item.value === null) {
										errors[item.key] = `Select valid ${item.label} from the list`;
									}
								}
							}
							if (Object.keys(errors).length > 0) {
								setErrorCells(errors);
							} else {
								const params = getFiltersParams(selectedInputs);
								dispatch(
									setAdvanceFilter({
										filters: params,
										isAdvanceFilterApplied: true,
									}),
								);
								onApply(params);
							}
						}}
					>
						Apply Filters
					</button>
				</div>
			</div>
		</Modal>
	);
};

export default AdvanceFilter;
